import { OrganizationRow } from 'components/tables/data/organization/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the organization id.
 */
export default function OrganizationIdColumn({ data: { organizationId } }: { data: OrganizationRow }) {
  return <P3Regular color="gray.8">{organizationId}</P3Regular>;
}
